<template>
  <div class="layout-center-wrap">
    <!-- 상단 타이틀 -->
    <section class="page-tit__wrap">
      <h1 class="page-tit__sub">마이페이지</h1>
      <h2 class="page-tit">취약점 신고 통계 및 접수내역</h2>
    </section>
    <!-- 자주 묻는 질문 -->
    <section class="section-accordion__wrap type-faq">
      <h2 class="section-title">자주 묻는 질문</h2>
      <!-- 1. 진행상태는 무슨 의미인가요? -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            :aria-expanded="activeIndex === 0"
            aria-controls="panel-1"
            id="accordion-trigger-1"
            @click="toggle(0)"
          >
            <span class="section-accordion__num" aria-hidden="true">Q1</span>
            <span class="section-accordion__title"
              >진행상태는 무슨 의미인가요?</span
            >
            <span class="section-accordion__chevron" aria-hidden="true">
              <i class="svg_icon icon_arrow_down"></i>
            </span>
          </button>
        </h3>
        <div
          id="panel-1"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-1"
          v-show="activeIndex === 0"
        >
          <div class="section-accordion__content">
            <div class="section-accordion__inner">
              <p class="section-accordion__desc">
                - 등록 : 취약점 할당 전 단계 <br />
                - 분석 : 취약점이 분석가에게 할당된 상태 <br />
                - 평가 : 취약점분석이 완료되어 평가 진행중인상태 <br />
                - 완료 : 취약점 평가가 완료된 상태
              </p>
              <span class="sr-only">
                {{ activeIndex === 0 ? "보임" : "숨김" }}
              </span>
            </div>
          </div>
        </div>
      </article>
      <!-- 2. 왜 KVE 번호가 보이지 않나요? -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            :aria-expanded="activeIndex === 1"
            aria-controls="panel-2"
            id="accordion-trigger-2"
            @click="toggle(1)"
          >
            <span class="section-accordion__num" aria-hidden="true">Q2</span>
            <span class="section-accordion__title"
              >왜 KVE 번호가 보이지 않나요?</span
            >
            <span class="section-accordion__chevron" aria-hidden="true">
              <i class="svg_icon icon_arrow_down"></i>
            </span>
          </button>
        </h3>
        <div
          id="panel-2"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-2"
          v-show="activeIndex === 1"
        >
          <div class="section-accordion__content">
            <div class="section-accordion__inner">
              <p class="section-accordion__desc">
                - 등록 : 취약점 할당 전 단계 <br />
                - 분석 : 취약점이 분석가에게 할당된 상태 <br />
                - 평가 : 취약점분석이 완료되어 평가 진행중인상태 <br />
                - 완료 : 취약점 평가가 완료된 상태
              </p>
              <span class="sr-only">
                {{ activeIndex === 1 ? "보임" : "숨김" }}
              </span>
            </div>
          </div>
        </div>
      </article>
      <!-- 3. 언제 결과가 나오나요? -->
      <article class="section-accordion__item">
        <h3 class="section-accordion__header">
          <button
            type="button"
            class="section-accordion__btn"
            :aria-expanded="activeIndex === 2"
            aria-controls="panel-3"
            id="accordion-trigger-3"
            @click="toggle(2)"
          >
            <span class="section-accordion__num" aria-hidden="true">Q3</span>
            <span class="section-accordion__title">결과가 나오나요?</span>
            <span class="section-accordion__chevron" aria-hidden="true">
              <i class="svg_icon icon_arrow_down"></i>
            </span>
          </button>
        </h3>
        <div
          id="panel-3"
          class="section-accordion__panel"
          role="region"
          aria-labelledby="accordion-trigger-3"
          v-show="activeIndex === 2"
        >
          <div class="section-accordion__content">
            <div class="section-accordion__inner">
              <p class="section-accordion__desc">
                - 등록 : 취약점 할당 전 단계 <br />
                - 분석 : 취약점이 분석가에게 할당된 상태 <br />
                - 평가 : 취약점분석이 완료되어 평가 진행중인상태 <br />
                - 완료 : 취약점 평가가 완료된 상태
              </p>
              <span class="sr-only">
                {{ activeIndex === 2 ? "보임" : "숨김" }}
              </span>
            </div>
          </div>
        </div>
      </article>
      <p class="section-accordion__info">
        ※ 문의사항은 [KNVD 안내]-[자주 묻는 질문]을 참고 부탁드리며, 그 외
        신고포상제 취약점 조회 문의는 vuln_notice@krcert.or.kr 으로 요청
        바랍니다.
      </p>
    </section>
    <!-- 취약점 신고 내역 -->
    <section class="section-pt report-history">
      <!-- 취약점 신고 내역 head -->
      <div class="section-title__wrap has-btns">
        <h3 class="section-title">취약점 신고 내역</h3>
        <div class="btn__wrap">
          <button
            type="button"
            class="btn btn--m btn--medium_gray btn--m_full"
            @click="showPopupSearch = true"
          >
            <i class="svg_icon icon_filter blue"></i>필터
          </button>
          <button type="button" class="btn btn--m btn--blue btn--m_full">
            취약점 인증서
          </button>
        </div>
      </div>
      <!-- 취약점 신고 내역 테이블 -->
      <table class="board-list type-block--mobile">
        <caption>
          취약점 신고 내역 입니다.
        </caption>
        <colgroup>
          <col width="10%" />
          <col width="12%" />
          <col />
          <col width="14%" />
          <col width="12%" />
          <col width="10%" />
          <col width="14%" />
        </colgroup>
        <thead>
          <tr>
            <th scope="col">순번</th>
            <th scope="col">상태</th>
            <th scope="col">제목</th>
            <th scope="col">KVE/CVE</th>
            <th scope="col">위험도</th>
            <th scope="col">포상금(만원)</th>
            <th scope="col">제보일</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="no-field">2650</td>
            <td class="info-field">
              <div class="report-status">
                <button
                  class="report-status__btn u-bold"
                  aria-describedby="tooltip-1"
                  @click="toggleTooltip(1)"
                  @mouseover="openTooltip(1)"
                  @mouseleave="closeTooltip(1)"
                  @focus="openTooltip(1)"
                  @blur="closeTooltip(1)"
                  aria-expanded="false"
                  aria-controls="tooltip-1"
                >
                  분석
                  <i class="svg_icon icon_time gray" aria-hidden="true"></i>
                  <span class="sr-only">상태 프로세스 보기</span>
                </button>
                <!-- 팝오버(툴팁) -->
                <div
                  v-if="openIndex === 1"
                  id="tooltip-1"
                  class="report-status__popover"
                  role="tooltip"
                  aria-live="polite"
                >
                  <div class="report-status__popover-inner">
                    <Report_timeline />
                  </div>
                  <span class="report-status__arrow" aria-hidden="true"></span>
                </div>
              </div>
            </td>
            <td class="tit-field">
              <a href="#" class="ellipsis" title="사이버 보안 취약점 정보 포털"
                >사이버 보안 취약점 정보 포털</a
              >
            </td>
            <td class="info-field">
              <span class="th--only-mobile">KVE/CVE</span>KVE-2025-0001
            </td>
            <td class="info-field">
              <span class="th--only-mobile">위험도</span>None(없음)
            </td>
            <td class="info-field">
              <span class="th--only-mobile">포상금(만원)</span>5
            </td>
            <td class="info-field">
              <span class="th--only-mobile">제보일</span>2025-05-31 11:05:66
            </td>
          </tr>
          <tr>
            <td class="no-field">2649</td>
            <td class="info-field">
              <div class="report-status">
                <button
                  class="report-status__btn u-bold"
                  aria-describedby="tooltip-2"
                  @click="toggleTooltip(2)"
                  @mouseover="openTooltip(2)"
                  @mouseleave="closeTooltip(2)"
                  @focus="openTooltip(2)"
                  @blur="closeTooltip(2)"
                  aria-expanded="false"
                  aria-controls="tooltip-2"
                >
                  미회신
                  <i class="svg_icon icon_time gray" aria-hidden="true"></i>
                  <span class="sr-only">상태 프로세스 보기</span>
                </button>
                <!-- 팝오버(툴팁) -->
                <div
                  v-if="openIndex === 2"
                  id="tooltip-2"
                  class="report-status__popover"
                  role="tooltip"
                  aria-live="polite"
                >
                  <div class="report-status__popover-inner">
                    <Report_timeline />
                  </div>
                  <span class="report-status__arrow" aria-hidden="true"></span>
                </div>
              </div>
            </td>
            <td class="tit-field">
              <a href="#" class="ellipsis" title="사이버 보안 취약점 정보 포털"
                >사이버 보안 취약점 정보 포털</a
              >
            </td>
            <td class="info-field">
              <span class="th--only-mobile">KVE/CVE</span>KVE-2025-0001
            </td>
            <td class="info-field">
              <span class="th--only-mobile">위험도</span>None(없음)
            </td>
            <td class="info-field">
              <span class="th--only-mobile">포상금(만원)</span>5
            </td>
            <td class="info-field">
              <span class="th--only-mobile">제보일</span>2025-05-31 11:05:66
            </td>
          </tr>
          <tr>
            <td class="no-field">2648</td>
            <td class="info-field">
              <div class="report-status green">
                <button
                  class="report-status__btn u-bold"
                  aria-describedby="tooltip-3"
                  @click="toggleTooltip(3)"
                  @mouseover="openTooltip(3)"
                  @mouseleave="closeTooltip(3)"
                  @focus="openTooltip(3)"
                  @blur="closeTooltip(3)"
                  aria-expanded="false"
                  aria-controls="tooltip-3"
                >
                  완료
                  <i class="svg_icon icon_time gray" aria-hidden="true"></i>
                  <span class="sr-only">상태 프로세스 보기</span>
                </button>
                <!-- 팝오버(툴팁) -->
                <div
                  v-if="openIndex === 3"
                  id="tooltip-2"
                  class="report-status__popover"
                  role="tooltip"
                  aria-live="polite"
                >
                  <div class="report-status__popover-inner">
                    <!-- <Report_timeline /> -->
                  </div>
                  <span class="report-status__arrow" aria-hidden="true"></span>
                </div>
              </div>
            </td>
            <td class="tit-field">
              <a href="#" class="ellipsis" title="사이버 보안 취약점 정보 포털"
                >사이버 보안 취약점 정보 포털</a
              >
            </td>
            <td class="info-field">
              <span class="th--only-mobile">KVE/CVE</span>KVE-2025-0001
            </td>
            <td class="info-field">
              <span class="th--only-mobile">위험도</span>None(없음)
            </td>
            <td class="info-field">
              <span class="th--only-mobile">포상금(만원)</span>5
            </td>
            <td class="info-field">
              <span class="th--only-mobile">제보일</span>2025-05-31 11:05:66
            </td>
          </tr>
        </tbody>
      </table>
      <Paging />
    </section>
    <Modal
      :visible="showPopupSearch"
      pop_tit="검색"
      popSizeClass="popup__container--sm pop_search"
      @close="showPopupSearch = false"
    >
      <template #pop_content>
        <!-- 신고 날짜 -->
        <fieldset class="input-form__item type-date-start-end">
          <legend class="input-form__legend">신고날짜</legend>
          <!-- 시작일 -->
          <div
            class="input-form__block type-box"
            role="group"
            aria-labelledby="start-group-label"
          >
            <span id="start-group-label" class="input-form__label"
              >조회 기간 시작일</span
            >
            <div class="input-form__field">
              <label for="month-s" class="sr-only">시작 월</label>
              <input
                type="date"
                id="month-s"
                name="month-s"
                class="input-form__input"
                value="1"
                aria-describedby="month-s-suffix"
                inputmode="numeric"
                pattern="0?[1-9]|1[0-2]"
              />
            </div>
          </div>
          <span style="margin-top: 10px">~</span>
          <!-- 종료일 -->
          <div
            class="input-form__block type-box"
            role="group"
            aria-labelledby="end-group-label"
          >
            <span id="end-group-label" class="input-form__label"
              >조회 기간 종료일</span
            >
            <div class="input-form__field">
              <label for="month-f" class="sr-only">종료 월</label>
              <input
                type="date"
                id="month-f"
                name="month-f"
                class="input-form__input"
                value="12"
                aria-describedby="month-f-suffix"
                inputmode="numeric"
                pattern="0?[1-9]|1[0-2]"
              />
            </div>
          </div>
        </fieldset>
        <!-- 상태 -->
        <fieldset class="input-form__item">
          <legend class="input-form__legend">상태</legend>
          <div class="input-form__block">
            <label for="select-status" class="sr-only">상태 선택</label>
            <select id="select-status" name="status">
              <option value="">전체</option>
            </select>
          </div>
        </fieldset>
      </template>
      <template #pop_buttons>
        <button type="button" class="btn btn--m btn--medium_gray">닫기</button>
        <button type="submit" class="btn btn--m btn--blue">검색</button>
      </template>
    </Modal>
  </div>
</template>
<script>
import Paging from "@/component/Paging.vue";
// import Report_timeline from "@/componen/t/Report_timeline.vue";
import { ref } from "vue";
import Modal from "@/component/Modal.vue";
export default {
  components: {
    Modal,
    Paging,
    // Report_timeline,
  },
  setup() {
    // data 정의
    const showPopupSearch = ref(false);
    const openIndex = ref(null);
    const activeIndex = ref(null);
    const isPc = () => window.matchMedia("(min-width: 1399.9px)").matches;
    //method정의
    const toggleTooltip = (i) => {
      openIndex.value = openIndex.value === i ? null : i;
    };
    const openTooltip = (i) => {
      if (isPc()) openIndex.value = i;
    };
    const closeTooltip = (i) => {
      if (isPc() && openIndex.value === i) openIndex.value = null;
    };
    const toggle = (i) => {
      activeIndex.value = activeIndex.value === i ? null : i;
    };
    // html에서 사용될 데이터 정의
    return {
      showPopupSearch,
      openIndex,
      activeIndex,
      toggleTooltip,
      openTooltip,
      closeTooltip,
      toggle,
    };
  },
};
</script>
